/** Fiscal year 2569 HR census and unit scores. Source rows for the /hr page. */

export const HR_FY2569_FISCAL_YEAR = 2569;

/**
 * Reported fiscal-year totals. These are the figures given for 2569.
 * They are not the average of the ward rows below.
 */
export const HR_FY2569_PUBLISHED_YEAR = {
  happinometer: 67.57,
  engagement: 71.22,
  jobSatisfaction: 67.56,
  turnoverRate: 2.88,
  turnoverResignations: 22,
} as const;

export const HR_FY2569_TURNOVER_QUARTERS = [
  { quarter: 1, label: '1/69', valuePercent: 0.67 },
  { quarter: 2, label: '2/69', valuePercent: 0.95 },
  { quarter: 3, label: '3/69', valuePercent: 0.27 },
  { quarter: 4, label: '4/69', valuePercent: 1.03 },
] as const;

export const HR_FY2569_ROLE_HEADERS = [
  'หัวหน้าพยาบาล',
  'ผู้ช่วยหัวหน้าพยาบาล',
  'ผู้ตรวจการพยาบาล',
  'หัวหน้าหอผู้ป่วย',
  'พยาบาล',
  'ผู้ช่วยพยาบาล',
  'เจ้าหน้าที่พยาบาล',
  'เจ้าหน้าที่บริหารงานทั่วไป',
  'เจ้าหน้าที่ธุรการ',
  'พนักงานซักรีด',
  'คนงานตึกผู้ป่วย',
  'คนงานทั่วไป',
] as const;

export type HrFy2569RoleCounts = [
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  number,
];

export type HrFy2569Unit = {
  unitNameRaw: string;
  roles: HrFy2569RoleCounts;
  total: number;
  happinometer: number;
  jobSatisfaction: number;
  engagement: number;
};

type SourceRow = [string, HrFy2569RoleCounts, number, number, number];

const SOURCE_ROWS: readonly SourceRow[] = [
  ['NSO (ผู้บริหาร)', [1, 4, 10, 26, 1, 0, 0, 0, 0, 0, 0, 0], 80.95, 81.55, 86.18],
  ['CCU', [0, 0, 0, 0, 16, 6, 0, 1, 0, 0, 0, 0], 66.3, 61.96, 70.62],
  ['MICU', [0, 0, 0, 0, 29, 6, 1, 1, 0, 0, 0, 0], 53.38, 54.73, 60.45],
  ['NICU', [0, 0, 0, 0, 36, 8, 0, 1, 0, 0, 0, 0], 66.11, 63.89, 69.09],
  ['SICU (PICU)', [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], 100, 100, 100],
  ['SICU', [0, 0, 0, 0, 22, 7, 0, 1, 0, 0, 0, 0], 62.9, 61.29, 62.43],
  ['OPD_MED', [0, 0, 0, 0, 17, 5, 6, 0, 0, 0, 0, 0], 66.96, 65.18, 68.73],
  ['OPD_SxOrthoEENT', [0, 0, 0, 0, 13, 13, 9, 0, 1, 0, 0, 0], 79.17, 84.03, 82],
  ['OPD_OBGYN', [0, 0, 0, 0, 10, 6, 6, 0, 0, 0, 0, 0], 78.41, 79.55, 81],
  ['OPD_GENP', [0, 0, 0, 0, 18, 5, 8, 0, 0, 0, 0, 0], 56.25, 53.91, 59.85],
  ['OPD_CHEMO', [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0], 62.5, 62.5, 52.43],
  ['CSSD (ซักฟอก และโรงนึ่ง)', [0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5, 0], 95.83, 95.83, 88.83],
  ['18A', [0, 0, 0, 0, 14, 10, 0, 1, 0, 0, 0, 0], 64, 65, 74.31],
  ['18B', [0, 0, 0, 0, 11, 3, 0, 1, 0, 0, 0, 0], 50, 43.33, 52.36],
  ['18C', [0, 0, 0, 0, 12, 5, 0, 1, 0, 0, 0, 0], 73.61, 79.17, 79.05],
  ['18D', [0, 0, 0, 0, 15, 7, 0, 1, 0, 0, 0, 0], 63.04, 64.13, 70.98],
  ['19A', [0, 0, 0, 0, 18, 12, 1, 1, 0, 0, 0, 0], 68.75, 69.53, 75.56],
  ['19B', [0, 0, 0, 0, 19, 10, 1, 2, 0, 0, 0, 0], 64.06, 64.84, 70.68],
  ['19D', [0, 0, 0, 0, 20, 12, 0, 1, 0, 0, 0, 0], 64.39, 64.39, 67.07],
  ['20B', [0, 0, 0, 0, 14, 3, 0, 1, 0, 0, 0, 0], 66.67, 68.06, 71.41],
  ['20C', [0, 0, 0, 0, 17, 13, 0, 1, 0, 0, 0, 0], 64.52, 65.32, 68.46],
  ['21D', [0, 0, 0, 0, 12, 8, 0, 1, 0, 0, 0, 0], 63.1, 61.9, 63.66],
  ['22A', [0, 0, 0, 0, 24, 18, 0, 1, 0, 0, 0, 0], 68.02, 69.77, 75.49],
  ['22B', [0, 0, 0, 0, 19, 11, 0, 1, 0, 0, 0, 0], 69.35, 68.55, 71.3],
  ['22C', [0, 0, 0, 0, 23, 11, 0, 1, 0, 0, 0, 0], 56.43, 57.14, 62.02],
  ['22D', [0, 0, 0, 0, 23, 12, 0, 1, 0, 0, 0, 0], 58.33, 58.33, 67.01],
  ['23A', [0, 0, 0, 0, 11, 8, 0, 1, 0, 0, 0, 0], 65, 67.5, 72.57],
  ['24A', [0, 0, 0, 0, 15, 8, 0, 2, 0, 0, 0, 0], 70, 70, 71.72],
  ['25A', [0, 0, 0, 0, 13, 5, 0, 1, 0, 0, 0, 0], 68.42, 67.11, 67.36],
  ['25B', [0, 0, 0, 0, 13, 6, 0, 1, 0, 0, 0, 0], 62.5, 62.5, 70.8],
  ['26B', [0, 0, 0, 0, 14, 6, 0, 1, 0, 0, 0, 0], 65.48, 66.67, 71.2],
  ['SW', [0, 0, 0, 0, 10, 7, 0, 1, 0, 0, 0, 0], 66.67, 65.28, 68.09],
  ['NSO', [0, 0, 0, 0, 5, 0, 0, 2, 1, 0, 0, 1], 69.44, 66.67, 73.61],
  ['BURN', [0, 0, 0, 0, 6, 4, 0, 0, 0, 0, 0, 0], 67.5, 65, 70.42],
  ['ERD', [0, 0, 0, 0, 33, 14, 0, 2, 0, 0, 0, 0], 67, 68, 71.04],
  ['CSSD', [0, 0, 0, 0, 0, 9, 11, 0, 1, 0, 0, 0], 79.76, 79.76, 81.51],
  ['HD', [0, 0, 0, 0, 10, 4, 1, 1, 0, 0, 0, 0], 70.31, 68.75, 72.09],
  ['BLO_BNK', [0, 0, 0, 0, 5, 3, 0, 0, 0, 0, 0, 0], 71.88, 75, 75.69],
  ['DR', [0, 0, 0, 0, 18, 8, 0, 0, 1, 0, 0, 0], 61.11, 58.33, 67.51],
  ['OR', [0, 0, 0, 0, 25, 4, 1, 1, 0, 0, 5, 0], 72.3, 71.62, 73.1],
  ['G10', [0, 0, 0, 0, 8, 3, 1, 1, 0, 0, 0, 0], 50, 53.85, 62.45],
];

function rowTotal(roles: HrFy2569RoleCounts): number {
  return roles.reduce((sum, count) => sum + count, 0);
}

export const HR_FY2569_UNITS: readonly HrFy2569Unit[] = SOURCE_ROWS.map(
  ([unitNameRaw, roles, happinometer, jobSatisfaction, engagement]) => ({
    unitNameRaw,
    roles,
    total: rowTotal(roles),
    happinometer,
    jobSatisfaction,
    engagement,
  }),
);

export function hrFy2569RoleColumnTotals(): HrFy2569RoleCounts {
  const totals = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] as HrFy2569RoleCounts;
  for (const unit of HR_FY2569_UNITS) {
    unit.roles.forEach((count, index) => {
      totals[index] += count;
    });
  }
  return totals;
}

export function hrFy2569GrandTotal(): number {
  return HR_FY2569_UNITS.reduce((sum, unit) => sum + unit.total, 0);
}
